import type {BuilderDecoration} from '../types'

export function isListType(type: string): boolean {
  return type === 'listUnordered' || type === 'listOrdered'
}

// Sort decorations with special handling for same start/end positions
export const sortDecorations = (a: BuilderDecoration, b: BuilderDecoration) => {
  if (a.from !== b.from) return a.from - b.from

  // When from are identical, adjust startSide based on traversal order
  // Modify startSide to reflect traversal order priority
  // Earlier traversal (lower number) gets lower precedence (smaller startSide)
  a.decoration.startSide = a.traversalOrder
  b.decoration.startSide = b.traversalOrder

  return (a.decoration.startSide || 0) - (b.decoration.startSide || 0)
}
